import { IUserTokenLoginInfo } from 'src/services/local-storage.service';
import {
  AuthRequest,
  AuthResponse,
  AuthErrorResponse,
  AuthGetMeResponse,
  heimdallInstance,
} from './index';

export class AuthService {
  static async getToken(
    data: Omit<AuthRequest, 'device_name' | 'device_token'>
  ): Promise<AuthResponse | AuthErrorResponse> {
    const response = await heimdallInstance.post('/auth/token', {
      ...data,
      // device_name e device_token são dados utilizados app via app-view
      device_name: 'spa-legado',
      device_token: null,
    });
    return response.data;
  }

  static async loginWithToken(payload: {
    token: string;
    customer_id: string;
  }): Promise<AuthResponse | AuthErrorResponse> {
    const response = await heimdallInstance.post(
      '/auth/loginWithToken',
      payload
    );
    return response.data;
  }

  // a sessãoId é validada e retorna os dados de token de autenticação
  // do proprio heimdall
  static async checkSessionById(
    sessionId: string
  ): Promise<IUserTokenLoginInfo> {
    const response = await heimdallInstance.get(
      `/auth/check-session?session_id=${sessionId}`
    );

    return response.data;
  }

  static async getMe(
    token: string
  ): Promise<AuthGetMeResponse | AuthErrorResponse> {
    const response = await heimdallInstance.get('/auth/get-me', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  static async getFoundationAllowed(token: string) {
    const response = await heimdallInstance.get('/auth/foundation/allowed', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  static async logout(token: string) {
    const response = await heimdallInstance.post(
      '/auth/logout',
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }
}
